import React, { useEffect, useState, useContext } from 'react';
import { ConfigContext } from '../../DynamicForm/DynamicForm';
import Popover from "../../../../../formik/refactorOut/components/Popper/Popover";
import { popoverLocation } from '../../../../../config/Configuration';
import Required from "../../../../components/Required";
import Markdown from "markdown-to-jsx";
import PBV_icon from '../../../../assets/pbv.png';
import Button from '../../../../components/Button/Button';
import './ReleaseDatesSection.scss';
import DisclosureOfSensitiveInformation from '../SensitiveInfoSection/DisclosureOfSensitiveInformationSection';
import { GetLanguageText } from '../../../../languages/languages';
import { CheckLanguage } from '../../../../languages/languages';

const ReleaseDatesSection = ({ formType }) => {

    const { formik, validationValues, dbFormSpec } = useContext(ConfigContext)

    const orgId = dbFormSpec.facility.orgId;
    const DisableFeeStatement = (dbFormSpec.DisableFeeStatement);

    const logData = window.location.origin.includes('app-vra.azurewebsites.net') || window.location.origin.includes('app-vra-test') || window.location.origin.includes('localhost');

    function DevLog() {
        if (logData) {
            console.log('VALUES', formik.values, 'ERRORS', formik.errors);
        }
    }

    const convertSubmitObject = async () => {

        if (formik.values.discloseTo === "1") {
            if (formType.includes('Patient')) {
                formik.setFieldValue('RFName', `${formik.values.PFName}`)
                formik.setFieldValue('RLName', `${formik.values.PLName}`)
                formik.setFieldValue('RName', `${formik.values.PFName} ${formik.values.PLName}`)
                // formik.setFieldValue('RPhone', formik.values.PPhone)
                formik.values.RPhone = formik.values.PPhone
                formik.setFieldValue('REmail', formik.values.PEmail)
                formik.setFieldValue('RFax', formik.values.PFax)
                formik.setFieldValue('RAddress1', formik.values.PAddress1)
                formik.setFieldValue('RAddress2', formik.values.PAddress2)
                formik.setFieldValue('RCity', formik.values.PCity)
                formik.setFieldValue('RState', formik.values.PState)
                formik.setFieldValue('RZip', formik.values.PZip)
            }
            else {
                formik.setFieldValue('RFName', `${formik.values.RepFName}`)
                formik.setFieldValue('RLName', `${formik.values.RepLName}`)
                formik.setFieldValue('RName', `${formik.values.RepFName} ${formik.values.RepLName}`)
                // formik.setFieldValue('RPhone', formik.values.RepPhone)
                formik.values.RPhone = formik.values.RepPhone
                formik.setFieldValue('REmail', formik.values.RepEmail)
                formik.setFieldValue('RFax', formik.values.RepFax)
                formik.setFieldValue('RAddress1', formik.values.RepAddress1)
                formik.setFieldValue('RAddress2', formik.values.RepAddress2)
                formik.setFieldValue('RCity', formik.values.RepCity)
                formik.setFieldValue('RState', formik.values.RepState)
                formik.setFieldValue('RZip', formik.values.RepZip)
            }
        }
        else if (formik.values.discloseTo === "2") {
            formik.setFieldValue('RName', `${formik.values.RFName} ${formik.values.RLName}`)
        }
        formik.values.PDOB1 && formik.setFieldValue('PDOB', new Date(formik.values.PDOB1).toLocaleDateString("en-US", { timeZone: 'UTC' }))
        formik.values.dosTo1 && formik.setFieldValue('dosto', new Date(formik.values.dosTo1).toLocaleDateString("en-US", { timeZone: 'UTC' }))
        formik.values.dosFrom1 && formik.setFieldValue('dosfrom', new Date(formik.values.dosFrom1).toLocaleDateString("en-US", { timeZone: 'UTC' }))

        if (dbFormSpec.facility.orgId.includes('7307')) {
            formik.setFieldValue("facilityList", Object.values(formik.values.facilityList))
        }
        else {
            formik.values.facilityList.map(
                (facility) => {
                    return formik.setFieldValue(facility, "on")
                }
            )
        }
        formik.values.infoToReleaseGroup.map(
            (releaseId) => {
                return formik.setFieldValue(`requesteditem${releaseId}`, "on")
            }
        )

        let physicianList = ""
        for (let property in formik.values) {
            if (property.includes('physician#') && formik.values[property].length > 0) {
                physicianList = physicianList.concat(formik.values[property], " ")
                if (physicianList.length > 0) {
                    await formik.setFieldValue('inputPhysicianNames', physicianList)
                }
            }
        }
        let recordList = ""
        for (let property in formik.values) {
            if (property.includes('txtotherrecords#')) {
                recordList = recordList.concat(`${formik.values[property]},`, " ")
                formik.setFieldValue('txtotherrecords', recordList)
            }
        }

        // reset customcheckbox keys in case user backed up and changed items.
        let formikKeys = Object.keys(formik.values);

        for (var valuesI = 0; valuesI < formikKeys.length; valuesI++) {
            let formikKey = formikKeys[valuesI];
            if (formikKey.startsWith("CustomCheckbox_")) {
                formik.setFieldValue(formikKey, false);
            }
        }

        formik.values.sensitiveInfo.forEach((sensitiveInfoType) => {
            formik.setFieldValue("CustomCheckbox_sensitiveInfo_" + sensitiveInfoType, true);
        });

        formik.values.facilityList.forEach((facilityListEntry) => {
            formik.setFieldValue("CustomCheckbox_facilityList_" + facilityListEntry, true);
        });

        formik.values.infoToReleaseGroup.forEach((infoToReleaseGroupEntry) => {
            formik.setFieldValue("CustomCheckbox_infoToReleaseGroup_" + infoToReleaseGroupEntry, true);
        });

        let sensitiveInfoTypes = ['psy', 'drug', 'HIV', 'STD', 'genetics']
        sensitiveInfoTypes.forEach((type) => {
            !formik.values.sensitiveInfo.includes(type.toUpperCase()) ? formik.setFieldValue(`exclude${type}`, 'on') : delete formik.values[`exclude${type}`]
        })

        if (formik.values.sensitiveInfo.length === 5) {
            formik.setFieldValue('authorizeAll', "on")
        }

        let signdate = new Date();
        formik.setFieldValue("SignatureDateTime", signdate.toLocaleDateString("en-US") + " " + signdate.toLocaleTimeString("en-US"));

        if (formik.values.RepLName) {
            formik.setFieldValue("SignatureName", `${formik.values.RepFName} ${formik.values.RepMName}  ${formik.values.RepLName}`);
        } else {
            formik.setFieldValue("SignatureName", `${formik.values.PFName} ${formik.values.PMName}  ${formik.values.PLName}`);
        }


        formik.setFieldValue("BrowserDetails", navigator.userAgent);


    }

    const checkForLocalErrors = () => {

    }

    const languageID = CheckLanguage(dbFormSpec);



    if (languageID != "default") {
        const languageText = GetLanguageText(languageID);


        return (
            validationValues.page.form.sections.releaseDatesSection.active ?
                <>
                    <div id='releaseDatesSection'>
                        <div className="submit-section">
                            <DisclosureOfSensitiveInformation />
                            <p className='statement' style={DisableFeeStatement ? { display: 'none' } : { textAlign: 'left' }} >
                                {languageText.deliveryMethod.feeInfo}
                            </p>
                        </div>
                        <Button classes='submit-button' label={`${languageText.PageHeaders.buttons.reviewRequest}`} onClick={() => { checkForLocalErrors(); convertSubmitObject(); DevLog(); }} style={{ backgroundColor: dbFormSpec.color }} type={'submit'} />
                    </div>
                    <img src={PBV_icon} alt={languageText.PageHeaders.AltText.PoweredByVerisma} className='pbv-icon' />
                    <div className="PrivacyPolicy"> <a href="https://verisma.com/privacy-policy" target="_blank" rel="noopener noreferrer" >{languageText.PageFooter.PrivacyPolicy}
                    </a>
                    </div>
                </>
                :
                <>   <img src={PBV_icon} alt={languageText.PageHeaders.AltText.PoweredByVerisma} className='pbv-icon' />
                    <div className="PrivacyPolicy"> <a href="https://verisma.com/privacy-policy" target="_blank" rel="noopener noreferrer" >{languageText.PageFooter.PrivacyPolicy}</a>
                    </div></>
        );

    }
    else {
        return (
            validationValues.page.form.sections.releaseDatesSection.active ?
                <>
                    <div id='releaseDatesSection'>
                        <div className="submit-section">
                            <DisclosureOfSensitiveInformation />
                            <p className='statement' style={DisableFeeStatement ? { display: 'none' } : { textAlign: 'left' }} >
                                A fee covering the costs of labor, supplies and postage associated with these records may apply to this request. If a fee does apply, you will be notified before your request is processed.
                            </p>
                        </div>
                        <Button classes='submit-button' label={'Review Request'} onClick={() => { checkForLocalErrors(); convertSubmitObject(); DevLog(); }} style={{ backgroundColor: dbFormSpec.color }} type={'submit'} />
                    </div>
                    <img src={PBV_icon} alt="Powered by Verisma" className='pbv-icon' />
                    <div className="PrivacyPolicy"> <a href="https://verisma.com/privacy-policy" target="_blank" rel="noopener noreferrer" >Verisma's Privacy Policy</a>
                    </div>
                </>
                :
                <>
                    <img src={PBV_icon} alt="Powered by Verisma" className='pbv-icon' />
                    <div className="PrivacyPolicy"> <a href="https://verisma.com/privacy-policy" target="_blank" rel="noopener noreferrer" >Verisma's Privacy Policy</a>
                    </div>
                </>
        );
    }
};

export default ReleaseDatesSection;